// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"8ba8a49c","427":"840ffba1","462":"cbb7390a","624":"39f6731d","712":"39d3004c","785":"4116148a","791":"185c25f0","831":"4882e693","914":"ec779dd1","958":"80821786"}[chunkId] + ".chunk.js";
};